"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignallingTopics = exports.SignallingTypes = void 0;
var SignallingTypes;
(function (SignallingTypes) {
    SignallingTypes["answer"] = "answer";
    SignallingTypes["offer"] = "offer";
    SignallingTypes["iceCandidate"] = "iceCandidate";
    SignallingTypes["connect"] = "connect";
    SignallingTypes["disconnectPlayer"] = "disconnectPlayer";
})(SignallingTypes = exports.SignallingTypes || (exports.SignallingTypes = {}));
var SignallingTopics;
(function (SignallingTopics) {
    SignallingTopics["WEBRTC_UNREAL_STREAM"] = "WEBRTC_UNREAL_STREAM";
    SignallingTopics["WEBRTC_AVAILABLE"] = "WEBRTC_AVAILABLE";
})(SignallingTopics = exports.SignallingTopics || (exports.SignallingTopics = {}));
//# sourceMappingURL=Signalling.js.map